/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * How a team was marked ready — TELEMETRY (co-presence verified from game state), MANUAL (captain button), SYSTEM (simulator/admin flows)
 * @export
 */
export const MatchReadySource = {
    TELEMETRY: 'TELEMETRY',
    MANUAL: 'MANUAL',
    SYSTEM: 'SYSTEM'
} as const;
export type MatchReadySource = typeof MatchReadySource[keyof typeof MatchReadySource];


export function instanceOfMatchReadySource(value: any): boolean {
    for (const key in MatchReadySource) {
        if (Object.prototype.hasOwnProperty.call(MatchReadySource, key)) {
            if (MatchReadySource[key as keyof typeof MatchReadySource] === value) {
                return true;
            }
        }
    }
    return false;
}

export function MatchReadySourceFromJSON(json: any): MatchReadySource {
    return MatchReadySourceFromJSONTyped(json, false);
}

export function MatchReadySourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatchReadySource {
    return json as MatchReadySource;
}

export function MatchReadySourceToJSON(value?: MatchReadySource | null): any {
    return value as any;
}

export function MatchReadySourceToJSONTyped(value: any, ignoreDiscriminator: boolean): MatchReadySource {
    return value as MatchReadySource;
}

